export const createComprehendTool = (handler) => {
  return {
    type: 'function',
    name: 'finish_note',
    description:
      'This function will finalize the note, and push it to the EMR. This can be called more than once.',
    parameters: {
      type: 'object',
      strict: true,
      properties: {},
      required: [],
    },
    handler: handler,
  };
};

export const createToggleRecordingTool = (handler) => {
  return {
    type: 'function',
    name: 'toggle_recording',
    description:
      'This function will start or stop the audio recording. If recording is currently active, it will stop. If recording is stopped, it will start. If the user says "STOP THE RECORDER" this is the one we should call, but most other stops, should do the stop listening tool.',
    parameters: {
      type: 'object',
      strict: true,
      properties: {},
      required: [],
    },
    handler: handler,
  };
};

export const createChangePatientTool = (handler) => {
  return {
    type: 'function',
    name: 'change_patient',
    description:
      'Opens the patient selection interface to change or select a different patient for the current visit.',
    parameters: {
      type: 'object',
      strict: true,
      properties: {},
      required: [],
    },
    handler: handler,
  };
};
